<script>

	import SingleStringView from './single-string/SingleStringView.vue';
	import ShoppingTrolley from '../ShoppingTrolley.vue';

	export default {
        provide() {
            return {
                stringsLayoutState: this.sharedState
            }
        },

		props: ['configurations', 'is-lever'],

		components: { SingleStringView, ShoppingTrolley },

		data() {
			return {
				table: new Table({
					configurations: this.configurations
				}),

				reverse: false,
				isActive: false,
                sharedState: {
				    activeRow: this.configurations[0].position
                }
			}
		},

        created() {
            this.orderBy();
        },

		methods: {

            orderBy(ord = 'asc') {
                this.table.configurations = _.orderBy(this.table.configurations, 'position', ord)
            },

			toggleTrolley() {
                $('#trolleyModal').modal('toggle');
			}
		},

		filters: {
			prettyNote: (note) => {
				return note.replace('/', '').trim();
			}
		}
	}
</script>